<template>
  <div class="codeInput">
    <el-input
      v-for="input in inputs"
      :key="input.index"
      :ref="input.index"
      v-model="input.value"
      autocomplete="off"
      maxlength="1"
      type="password"
      autofocus
      @input="oninput()"
    />
  </div>
</template>

<script>
export default {
  name: "CodeInput",
  props: {
    size: {
      type: Number,
      required: false,
      default: 6
    }
  },
  data: () => ({
    inputs: []
  }),
  watch: {
    inputs() {
      this.$nextTick(() => {
        // focus first on load
        this.focusInput(0)
      })
    }
  },
  mounted() {
    if (this.size) {
      this.inputs = Array.from({ length: this.size }, (v, k) => ({ index: k + 1, value: '' }))
    }
  },
  methods: {
    focusInput(index) {
      let first = this.inputs[index].index
      let firstInput = this.$refs[first][0]
      firstInput.focus()
    },
    resetInput(index) {
      this.inputs[index].value = ''
    },
    oninput() {
      const code = this.inputs.reduce((p, n) => p + n.value, '')
      if (/^[a-z0-9]+$/i.test(code)) {
        if (code.length === this.size) {
          // handle change
          this.$emit('onchange', code)
        } else {
          // focus next input
          this.focusInput(code.length)
        }
      } else {
        // non alphanumeric 
        this.resetInput(code.length > 0 ? code.length - 1 : 0)
      }
    },
    onsubmit() {
      // handle submit
      this.$emit('onsubmit')
    }
  }
}
</script>

<style lang="scss">
$c: '.codeInput';

#{$c} {
  display: flex;
  flex-direction: row;

  input {
    margin: 2px;
    padding: 25px 0;
    font-size: 32px;
    width: 45px;
    border: 2px solid #333333;
    text-align: center;
  }
}
</style>